import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Progress, Typography } from 'foundations-library/components'
import { LiveReceptionistUsageSummaryScript } from 'interfaces'

const jss = () => ({
    minutesUsed: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4
    },
    text: {
        display: 'flex',
        justifyContent: 'space-between'
    }
})

const useStyles = makeStyles(jss)

type PropsType = Pick<LiveReceptionistUsageSummaryScript, 'usedMinutes' | 'planMinutes'>

/** Displays used minutes against the script's plan allowance. */
const MinutesUsed = ({ usedMinutes, planMinutes }: PropsType): JSX.Element => {
    const styles = useStyles()
    const color = 'destructive-700'
    const percentage = planMinutes > 0 ? Math.round(usedMinutes / planMinutes * 100) : 0

    return <div className={styles.minutesUsed}>
        <div className={styles.text}>
            <Typography variant='body2' style={{ whiteSpace: 'nowrap' }}>
                <strong>{usedMinutes}</strong> of {planMinutes}
            </Typography>
            <Typography variant='body2' color={color}>
                <strong>{usedMinutes > planMinutes ? 'Over plan' : `${percentage}%`}</strong>
            </Typography>
        </div>
        <Progress
            value={usedMinutes}
            max={planMinutes}
            height={8}
            bgColor='neutral-100'
            bufferColor={color}
        />
    </div>
}

export default MinutesUsed
